import AppletProfileSession from "./applet-profile-session.entity";
import { IAppletProfileSession } from "./types/applet-profile-session.interface";

export default class CompanySession {
  public appletAssessmentInstalled = false;

  public appletIdentityInstalled = false;

  public appletLocationInstalled = false;

  public appletPhotoInstalled = false;

  public appletRankingInstalled = false;

  public appletSearchInstalled = false;

  public appletTransferInstalled = false;

  public appletFleetInstalled = false;

  public logo = '';

  public color = '';

  public profiles: AppletProfileSession[];

  public segments: string[];

  constructor(data: any = {}) {
    this.appletAssessmentInstalled = data.applet_assessment_installed || false;
    this.appletIdentityInstalled = data.applet_identity_installed || false;
    this.appletLocationInstalled = data.applet_location_installed || false;
    this.appletPhotoInstalled = data.applet_photo_installed || false;
    this.appletRankingInstalled = data.applet_ranking_installed || false;
    this.appletSearchInstalled = data.applet_search_installed || false;
    this.appletTransferInstalled = data.applet_transfer_installed || false;
    this.appletFleetInstalled = data.applet_fleet_installed || false;
    this.logo = data.logo || '';
    this.color = data.color || '';
    this.profiles = (data.profiles && data.profiles.length) ? data.profiles
      .map((profile: IAppletProfileSession) => new AppletProfileSession(profile)) : [];
    this.segments = data.segments || [];
  }
}
